<template>
  <require from="controls/as-widget-list"></require>

  <div class="country-visits-panel">
    <as-widget-list items.bind="items" default-kind="country-visit" hide-last-remove="true"></as-widget-list>
  </div>
</template>
